'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  line-height: ', 'px;\n'], ['\n  display: inline-block;\n  line-height: ', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: ', 'px;\n  color: ', ';\n  font-family: ', ';\n'], ['\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: ', 'px;\n  color: ', ';\n  font-family: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: relative;\n  cursor: pointer;\n\n  ', ': ', 'px;\n\n  &:hover {\n    color: ', ';\n    .icon {\n      fill: ', ';\n    }\n  }\n'], ['\n  position: relative;\n  cursor: pointer;\n\n  ', ': ', 'px;\n\n  &:hover {\n    color: ', ';\n    .icon {\n      fill: ', ';\n    }\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin-right: 8px;\n'], ['\n  margin-right: 8px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

var _nitroLoading = require('../nitro-loading');

var _nitroLoading2 = _interopRequireDefault(_nitroLoading);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var styles = {
  layout: {
    horizontal: 'flex-direction: row;',
    vertical: 'flex-direction: column;'
  },
  align: {
    left: '&:last-child {\n      margin: 0;\n    } margin-right',
    right: '&:first-child {\n      margin: 0;\n    } margin-left'
  }
};

var LinksWrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.lineHeight;
});

LinksWrapper.displayName = 'LinksWrapper';
var DefaultLinks = _styledComponents2.default.ul(_templateObject2, function (props) {
  return props.theme.size[props.size];
}, function (props) {
  return props.theme.color.base2;
}, function (props) {
  return props.theme.font.bold;
});
DefaultLinks.displayName = 'DefaultLinks';
DefaultLinks.defaultProps = {
  size: '3'
};

var LayoutLinks = (0, _styledComponents2.default)(DefaultLinks)(_templateObject3, (0, _helpers.getStyle)(styles.layout, 'layout'));

LayoutLinks.displayName = 'LayoutLinks';
var ColorLinks = (0, _styledComponents2.default)(LayoutLinks)(_templateObject4, function (props) {
  return props.theme.color[props.variant];
});

ColorLinks.displayName = 'ColorLinks';
var Link = _styledComponents2.default.li(_templateObject5, (0, _helpers.getStyle)(styles.align, 'align'), function (props) {
  return props.gap;
}, function (props) {
  return (0, _helpers.darkenColor)(props.theme.color[props.variant]);
}, function (props) {
  return (0, _helpers.darkenColor)(props.theme.color[props.variant]);
});

Link.displayName = 'Link';
Link.defaultProps = {
  align: 'left',
  gap: 30
};

var Icon = _styledComponents2.default.i(_templateObject6);

Icon.displayName = 'Icon';
var NitroLinks = function NitroLinks(_ref) {
  var data = _ref.data,
      layout = _ref.layout,
      active = _ref.active,
      action = _ref.action,
      variant = _ref.variant,
      size = _ref.size,
      align = _ref.align,
      noLabel = _ref.noLabel,
      disabled = _ref.disabled,
      noMargin = _ref.noMargin,
      noFloating = _ref.noFloating,
      gap = _ref.gap,
      lineHeight = _ref.lineHeight,
      className = _ref.className;

  var links = data.map(function (link, index) {
    var handleLinkClick = function handleLinkClick() {
      if (disabled) return;

      if (link.url) window.open(link.url, '_blank');
      if (link.action) {
        link.action(link);
      }
      if (action) action(link);
    };

    var label = _react2.default.createElement(
      'span',
      { className: 'link-label' },
      link.label
    );
    var icon = link.icon ? _react2.default.createElement(_nitroIcon2.default, { name: link.icon, variant: link.iconVariant || variant, size: size, right: 8 }) : '';

    if (noLabel) {
      label = null;
    }
    return _react2.default.createElement(
      Link,
      { key: index, align: align, gap: gap, variant: variant, onClick: handleLinkClick },
      link.loading ? _react2.default.createElement(_nitroLoading2.default, { size: 14, thickness: 2, position: 'left' }) : icon,
      label
    );
  });

  return _react2.default.createElement(
    LinksWrapper,
    { className: className, lineHeight: lineHeight },
    _react2.default.createElement(
      ColorLinks,
      { layout: layout, variant: variant },
      links
    )
  );
};

NitroLinks.propTypes = {
  action: _propTypes2.default.func,
  active: _propTypes2.default.string,
  className: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  data: _propTypes2.default.array.isRequired,
  layout: _propTypes2.default.string,
  iconOnly: _propTypes2.default.bool,
  noLabel: _propTypes2.default.bool,
  size: _propTypes2.default.string,
  align: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  noMargin: _propTypes2.default.bool
};

exports.default = NitroLinks;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-links/NitroLinks.js
// module id = 3012
// module chunks = 4